<template>
  <v-card>
    <v-container class="pa-0">
      <v-card-title>
        <span class="text-h5">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-form v-model="isFormValid" ref="prestador-form" @submit.prevent="save()">
          <v-container>
            <v-row v-if="!prestadorSearched">
              <v-col
                :cols="isMobile ? '12' : '3'"
                :sm="isMobile ? 12 : 4"
                class="py-0"
              >
                <v-text-field
                  label="CUIT"
                  v-model="cuitBusqueda"
                  density="compact"
                  variant="outlined"
                  v-mask="['##-#######-#', '##-########-#']"
                  :rules="
                    cuitBusqueda !== null &&
                    cuitBusqueda !== undefined &&
                    cuitBusqueda !== ''
                      ? rules.required.concat(
                          rules.validateCUITCUIL(cuitBusqueda)
                        )
                      : []
                  "
                ></v-text-field>
              </v-col>
              <v-col
                :cols="isMobile ? 12 : 3"
                :md="isMobile ? 12 : 6"
                class="py-0"
              >
                <v-btn
                  color="primary"
                  variant="flat"
                  @click="searchPrestador()"
                  :disabled="cuitBusqueda == null || cuitBusqueda == ''"
                  :loading="isSearchLoading"
                >
                  Buscar
                </v-btn>
                <v-tooltip location="right">
                  <template v-slot:activator="{ props }">
                    <v-icon
                      color="primary"
                      size="25"
                      class="pl-5"
                      v-bind="props"
                    >
                      {{ infoIcon }}
                    </v-icon>
                  </template>
                  <span>Buscar usuario en el sistema</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <div v-if="prestadorSearched">
              <template v-if="isDataLoading">
                <v-skeleton-loader type="heading, text, text, article"></v-skeleton-loader>
              </template>
              <template v-else>
                <v-row>
                <v-col cols="12" class="pt-0">
                  <v-card elevation="1">
                    <v-card-title class="text-button pt-0">
                      Datos personales
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" :sm="isMobile ? 12 : 6" class="pb-0">
                          <v-text-field
                            label="Apellido/s y nombre/s"
                            v-model="apeNom"
                            density="compact"
                            variant="outlined"
                            :rules="
                              rules.required.concat([
                                rules.maxLength(apeNom, 60),
                              ])
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col :cols="isMobile ? 12 : 3" class="pb-0">
                          <v-select
                            :items="tiposDoc"
                            label="Tipo documento"
                            v-model="tipoDocSelected"
                            :rules="rules.required"
                            density="compact"
                            variant="outlined"
                            return-object
                            item-value="id"
                            item-title="value1"
                            clearable
                          ></v-select>
                        </v-col>
                        <v-col :cols="isMobile ? 12 : 3" class="pb-0">
                          <v-text-field
                            label="N° documento"
                            v-model="nroDoc"
                            density="compact"
                            variant="outlined"
                            v-mask="['#.###.###', '##.###.###', '########']"
                            :rules="
                              nroDoc !== null &&
                              nroDoc !== undefined &&
                              nroDoc !== '' &&
                              prestadorSearched
                                ? rules.required.concat([
                                    rules.minLength(
                                      nroDoc.replace('/./g', ''),
                                      7
                                    ),
                                  ])
                                : []
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col :cols="isMobile ? 12 : 2" class="pb-0">
                          <v-select
                            label="Sexo"
                            v-model="sexoSelected"
                            return-object
                            :items="sexos"
                            item-title="value"
                            item-value="value"
                            density="compact"
                            variant="outlined"
                            :rules="rules.required"
                            clearable
                          ></v-select>
                        </v-col>
                        <v-col cols="12" :sm="isMobile ? 12 : 3" class="pb-0">
                          <v-text-field
                            label="CUIT/CUIL"
                            v-model="cuil"
                            density="compact"
                            variant="outlined"
                            readonly
                            v-mask="['##-########-#', '##-#######-#']"
                            :rules="
                              cuil == null || cuil === ''
                                ? rules.required
                                : rules.required.concat(
                                    rules.validateCUITCUIL(cuil)
                                  )
                            "
                            @update:model-value="setUserName(cuil)"
                            @blur="onCuilChange"
                          ></v-text-field>
                        </v-col>
                        <v-col :cols="isMobile ? 12 : 4" class="pb-0">
                          <v-text-field
                            label="Código REFEPS"
                            v-model="codigoRefeps"
                            density="compact"
                            variant="outlined"
                            v-mask="'############'"
                            :rules="codigoRefeps && codigoRefeps !== '' 
                              ? [ rules.minLength(codigoRefeps, 12), rules.maxLength(codigoRefeps, 12) ] 
                              : []"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pt-0">
                  <v-card elevation="1">
                    <v-card-title class="text-button"
                      >Datos del prestador</v-card-title
                    >
                    <v-card-text>
                      <!-- SIEMPRE mostrar las tarjetas de relaciones -->
                      <v-card
                        v-for="(rel, idx) in relaciones"
                        :key="`rel-card-${idx}`"
                        class="mb-3"
                        variant="outlined"
                      >
                          <v-card-subtitle class="d-flex justify-space-between align-center px-4 pt-3">
                            <span class="text-subtitle-2">Matrícula</span>
                            <v-tooltip location="left">
                              <template v-slot:activator="{ props }">
                                <v-btn v-if="relaciones.length > 1" icon color="error" variant="text" @click="removeRelacion(idx)" v-bind="props">
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </template>
                              <span>Eliminar matrícula</span>
                            </v-tooltip>
                          </v-card-subtitle>
                          <v-card-text>
                            <v-row>
                              <v-col :cols="isMobile ? 12 : 4" class="pb-0">
                                <!-- Combo cuando usa Gecros -->
                                <v-autocomplete
                                  v-if="financiadorUsaGecros"
                                  v-model="rel.tipoPrestadorSelected"
                                  label="Tipo prestador"
                                  :items="tiposPrestador"
                                  item-title="value"
                                  item-value="id"
                                  density="compact"
                                  variant="outlined"
                                  :rules="rules.required"
                                  return-object
                                ></v-autocomplete>
                                <!-- Campo de texto cuando NO usa Gecros -->
                                <v-text-field
                                  v-else
                                  v-model="rel.tipoPrestadorTexto"
                                  label="Tipo prestador"
                                  density="compact"
                                  variant="outlined"
                                  :rules="
                                    rules.required.concat([
                                      rules.maxLength(rel.tipoPrestadorTexto, 50),
                                    ], rules.noStartingSpaces)
                                  "
                                ></v-text-field>
                              </v-col>
                              <v-col :cols="isMobile ? 12 : 2" class="pb-0">
                                <v-text-field
                                  label="Matrícula"
                                  v-model="rel.matriculaProv"
                                  density="compact"
                                  v-mask="'#########'"
                                  variant="outlined"
                                  :rules="rules.required"
                                ></v-text-field>
                              </v-col>
                              <v-col :cols="isMobile ? 12 : 6" class="pb-0">
                                <v-text-field
                                  label="Especialidad"
                                  v-model="rel.especialidadTexto"
                                  density="compact"
                                  variant="outlined"
                                ></v-text-field>
                              </v-col>
                              <v-col :cols="isMobile ? 12 : 4" class="pb-0">
                                <v-select
                                  v-model="rel.provinciaSelected"
                                  label="Provincia"
                                  variant="outlined"
                                  density="compact"
                                  :items="provincias"
                                  item-title="value"
                                  item-value="id"
                                  :loading="isProvinciaSelectLoading"
                                  :model-value="rel.provinciaSelected"
                                  :rules="rules.required"
                                  clearable
                                  return-object
                                ></v-select>
                              </v-col>
                              <v-col :cols="isMobile ? 12 : 8" class="pb-0">
                                <v-textarea
                                  v-model.trim="rel.entidadEmisoraMatricula"
                                  label="Entidad emisora de matrícula"
                                  variant="outlined"
                                  density="compact"
                                  auto-grow
                                  :rules="rel.entidadEmisoraMatricula && rel.entidadEmisoraMatricula !== '' ? [ rules.maxLength(rel.entidadEmisoraMatricula, 300) ] : []"
                                  rows="1"
                                ></v-textarea>
                              </v-col>
                              <v-col :cols="isMobile ? 12 : 9" class="pb-0">
                                <v-textarea
                                  v-model.trim="rel.domicilioPrescripcion"
                                  label="Domicilio prescripción"
                                  variant="outlined"
                                  density="compact"
                                  auto-grow
                                  :rules="rel.domicilioPrescripcion && rel.domicilioPrescripcion !== '' ? [ rules.maxLength(rel.domicilioPrescripcion, 150) ] : []"
                                  rows="1"
                                ></v-textarea>
                              </v-col>
                              <v-col :cols="isMobile ? 12 : 3" class="pb-0">
                                <v-text-field
                                  label="Teléfono"
                                  v-model="rel.telefono"
                                  density="compact"
                                  variant="outlined"
                                  v-mask="'###############'"
                                  :rules="[rules.maxLength(rel.telefono, 15)].concat(rel.telefono ? rules.telephoneRules : [])"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>

                        <v-row>
                          <v-col cols="12" class="pb-0">
                            <v-btn
                              class="to-right"
                              variant="outlined"
                              color="primary"
                              @click="addRelacionManual"
                            >
                              Agregar matrícula
                            </v-btn>
                          </v-col>
                        </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pt-0">
                  <v-card elevation="1">
                    <v-card-title class="text-button"
                      >Datos de usuario</v-card-title
                    >
                    <v-card-text>
                      <v-row :no-gutters="isMobile">
                        <v-col :cols="isMobile ? 12 : 3" class="pb-0">
                          <v-text-field
                            readonly
                            label="Nombre de usuario"
                            v-model="usuNom"
                            :rules="rules.required"
                            id="usuario-emisor-userNom"
                            density="compact"
                            variant="outlined"
                            autocomplete="usuario-emisor-userNom"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          :cols="isMobile ? 12 : 6"
                          class="pb-0"
                          v-if="prestadorNotFound"
                        >
                          <v-text-field
                            label="Email"
                            density="compact"
                            variant="outlined"
                            persistent-hint
                            v-model="correo"
                            :rules="
                              rules.required.concat(
                                [rules.maxLength(apeNom, 100)],
                                rules.emailRules
                              )
                            "
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              </template>
            </div>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="text" @click="closeModal(false)">
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              variant="flat"
              :disabled="!isFormValid || !prestadorSearched"
              :loading="isLoading"
              @click="save()"
            >
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
import rules from "@/utils/helpers/rules";
import { mapActions, mapGetters } from "vuex";
import enums from "@/utils/enums/index";

export default {
  name: "EditUsuarioEmisor",
  props: {
    usuarioEmisorItem: {
      type: Object,
      required: false,
    },
    financiadorId: {
      type: Number,
      required: true,
    },
    financiadorUsaGecros: {
      type: Boolean,
      required: true,
    },
    tiposDocItems: {
      type: Array,
      required: true,
    },
    tiposPrestadorItems: {
      type: Array,
      required: true,
    },
  },
      data() {
      return {
        formTitle: "",
        cuitBusqueda: "",
        domicilioPrescripcion: "",
        apeNom: "",
        tiposDoc: [],
        tipoDocSelected: null,
        nroDoc: "",
        sexos: [
          { id: 1, value: "F" },
          { id: 2, value: "M" },
          { id: 3, value: "X" }
        ],
        sexoSelected: null,
      matriculaProv: "",
      provincias: [],
      provinciaSelected: null,
      usuNom: "",
      telefono: "",
      codigoRefeps: "",
      entidadEmisoraMatricula: "",
      correo: "",
      rules: rules,
      isFormValid: false,
      isLoading: false,
      showPassword: false,
      isSearchLoading: false,
      isDataLoading: false,
      isProvinciaSelectLoading: false,
      tiposPrestador: [],
      tipoPrestadorSelected: null,
      infoIcon: enums.icons.SNB_INFO,
      prestadorSearched: false,
      cuil: "",
      prestadorNotFound: false,
      prestadorFounded: false,
      usuarioId: null,
      preId: null,
      preXFinId: null,
      relaciones: [],
      lastValidatedCuil: "", // Para controlar si cambió el CUIL
    };
  },
  created() {
    this.setSelects();
    if (this.usuarioEmisorItem != null) {
      this.cuitBusqueda = this.usuarioEmisorItem.preCuit.toString();
      this.searchPrestador();
      this.formTitle = "Editar usuario emisor";
    } else {
      this.formTitle = "Nuevo usuario emisor";
    }
  },
  computed: {
    ...mapGetters({
      isMobile: "menu/isMobile",
    }),
  },
  methods: {
    ...mapActions({
      searchPrestadorByCuit: "usuariosEmisores/searchPrestadorByCuit",
      saveUsuarioEmisor: "usuariosEmisores/saveUsuarioEmisor",
      validatePrestadorByCuil: "usuariosEmisores/validatePrestadorByCuil",
      getProvinciasAll: "taxonomy/getProvincias",
      setAlert: "user/setAlert",
    }),
    normalize(value) {
      if (!value) return "";
      try {
        return value
          .toString()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toUpperCase()
          .trim();
      } catch (_) {
        return (value?.toString() || "").toUpperCase().trim();
      }
    },
    async onCuilChange() {
      const cuil = (this.cuil || "").replaceAll("-", "");
      if (!cuil || cuil.length < 11) return;
      
      // No validar si el CUIL no cambió
      if (cuil === this.lastValidatedCuil) return;
      
      try {
        const res = await this.validatePrestadorByCuil({ cuil });
        if (res && res.status === 200 && res.data) {
          const profesional = res.data;
          const resultado = profesional.resultado || profesional.Resultado;
          if (resultado !== "OK") {
            if (resultado === "No encontrado") {
              this.setAlert({
                type: "warning",
                message:
                  "No se encontró profesional en REFEPS para proponer datos.",
              });
            }
            return;
          }
          
          // Modo NUEVO REGISTRO: proponer todos los datos
          if (this.prestadorNotFound) {
            this.handleNuevoRegistro(profesional);
          } 
          // Modo EDICIÓN: solo completar datos faltantes y alertar inconsistencias
          else if (this.prestadorFounded) {
            this.handleEdicionRegistro(profesional);
          }
          
          // Marcar este CUIL como ya validado
          this.lastValidatedCuil = cuil;
        }
      } catch (e) {
        console.error("Error proponiendo datos REFEPS", e);
        // Si hay error en nuevo registro, asegurar que al menos haya una relación vacía
        if (this.prestadorNotFound && (!this.relaciones || this.relaciones.length === 0)) {
          this.relaciones = [this.createRelacionBlank()];
        }
      }
    },
    handleNuevoRegistro(profesional) {
      // Proponer datos personales
      const nombreCompleto = profesional.nombreCompleto || "";
      if (nombreCompleto) {
        this.apeNom = nombreCompleto;
      }
      
      const cuilSisa = profesional.cuil || "";
      if (cuilSisa) {
        this.cuil = cuilSisa;
        this.setUserName(this.cuil);
      }
      
      // Setear DNI si viene
      const dniSisa = profesional.dni || "";
      if (dniSisa) {
        this.nroDoc = dniSisa;
      }

      const generoSisa = profesional.genero || "";
      if (generoSisa) {
        this.sexoSelected = this.sexos.find(s => generoSisa == 'male' ? s.value === 'M' : generoSisa == 'female' ? s.value === 'F' : s.value === 'X');
      }

      const codigo = profesional.refepsId || "";
      const matriculas = profesional.matriculas || [];
      const nuevasRelaciones = [];
      let profesionNombre = "";
      for (const m of matriculas) {
        const matricula = m.numero || "";
        const entidad = m.entidadExpedidora || "";
        const provNombre = m.jurisdiccion || "";
        const provincia =
          this.provincias.find(
            (p) => this.normalize(p.value) === this.normalize(provNombre)
          ) || null;
        const especialidades = m.especialidad ? [m.especialidad] : [];
        const profesion = m.profesion || "";
        if (!profesionNombre && profesion) profesionNombre = profesion;
        const rel = {
          tipoPrestadorSelected: null,
          tipoPrestadorTexto: "",
          matriculaProv: matricula,
          provinciaSelected: provincia || null,
          especialidades,
          especialidadTexto: especialidades.join(", "),
          entidadEmisoraMatricula: entidad,
          domicilioPrescripcion: this.domicilioPrescripcion || "",
          telefono: this.telefono || "",
        };
        // Intentar seleccionar Tipo prestador por profesion por relación
        if (profesion) {
          // SIEMPRE cargar el texto de SISA en el campo tipoPrestadorTexto
          rel.tipoPrestadorTexto = profesion;
          
          if (this.financiadorUsaGecros && this.tiposPrestador?.length) {
            // Si usa Gecros, buscar coincidencia en el combo
            const normProfRel = this.normalize(profesion).replace(/S$/, "");
            const matchTpRel = this.tiposPrestador.find((tp) => {
              const normVal = this.normalize(tp.value).replace(/S$/, "");
              return (
                normVal === normProfRel ||
                normVal.includes(normProfRel) ||
                normProfRel.includes(normVal)
              );
            });
            if (matchTpRel) rel.tipoPrestadorSelected = matchTpRel;
          }
        }
        nuevasRelaciones.push(rel);
      }
      this.relaciones = nuevasRelaciones.length
        ? nuevasRelaciones
        : [this.createRelacionBlank()];
      // También setear código REFEPS único si viene
      if (codigo && !this.codigoRefeps) this.codigoRefeps = codigo;
      // Intento global por si no se pudo en la relación (solo si usa Gecros)
      if (
        this.financiadorUsaGecros &&
        !this.tipoPrestadorSelected &&
        profesionNombre &&
        this.tiposPrestador?.length
      ) {
        const normProf = this.normalize(profesionNombre).replace(/S$/, "");
        const matchTp = this.tiposPrestador.find((tp) => {
          const normVal = this.normalize(tp.value).replace(/S$/, "");
          return (
            normVal === normProf ||
            normVal.includes(normProf) ||
            normProf.includes(normVal)
          );
        });
        if (matchTp) {
          this.$nextTick(() => {
            this.tipoPrestadorSelected = matchTp;
          });
        }
      }
    },
    handleEdicionRegistro(profesional) {
      const inconsistencias = [];
      
      // Verificar sexo: solo setear si está vacío, sino verificar inconsistencias
      const generoSisa = profesional.genero || "";
      if (generoSisa) {
        const sexoSisa = generoSisa == 'male' ? 'M' : generoSisa == 'female' ? 'F' : 'X';
        
        if (!this.sexoSelected) {
          // Solo setear si está vacío en la base de datos
          this.sexoSelected = this.sexos.find(s => s.value === sexoSisa);
        } else {
          // Verificar inconsistencia si ya hay un sexo cargado
          const sexoSistema = this.sexoSelected.value;
          if (sexoSistema !== sexoSisa) {
            inconsistencias.push(
              `Sexo difiere - Sistema: "${sexoSistema}"; REFEPS: "${sexoSisa}"`
            );
          }
        }
      }

      // Solo setear código REFEPS si está vacío
      const codigoSisa = profesional.refepsId || "";
      if (codigoSisa && !this.codigoRefeps) {
        this.codigoRefeps = codigoSisa;
      } else if (codigoSisa && this.codigoRefeps && codigoSisa !== this.codigoRefeps) {
        // Alertar si hay inconsistencia en código REFEPS
        inconsistencias.push(
          `Código REFEPS difiere: Sistema: "${this.codigoRefeps}"; REFEPS: "${codigoSisa}"`
        );
      }

      // Verificar inconsistencias en matrículas
      const matriculasSisa = profesional.matriculas || [];
      if (matriculasSisa.length > 0 && this.relaciones && this.relaciones.length > 0) {
        // Comparar cada matrícula del sistema con las de SISA
        for (const relSistema of this.relaciones) {
          const matSistema = (relSistema.matriculaProv || "").toString().trim();
          if (!matSistema) continue;
          
          // Buscar si esta matrícula existe en SISA
          const encontradaEnSisa = matriculasSisa.find(m => 
            (m.numero || "").toString().trim() === matSistema
          );
          
          if (!encontradaEnSisa) {
            inconsistencias.push(
              `Matrícula ${matSistema} no encontrada en REFEPS`
            );
          } else {
            // Verificar provincia si está seteada
            const provSistema = relSistema.provinciaSelected?.value;
            const provSisa = encontradaEnSisa.jurisdiccion || "";
            if (provSistema && provSisa && 
                this.normalize(provSistema) !== this.normalize(provSisa)) {
              inconsistencias.push(
                `Matrícula ${matSistema}: Provincia difiere - Sistema: "${provSistema}"; REFEPS: "${provSisa}"`
              );
            }
          }
        }
        
      }

      // Mostrar todas las inconsistencias encontradas
      if (inconsistencias.length > 0) {
        // Mostrar un mensaje por cada inconsistencia con un pequeño delay entre ellas
        inconsistencias.forEach((mensaje, index) => {
          setTimeout(() => {
            this.setAlert({
              type: "warning",
              message: mensaje
            });
          }, index * 3000); // 3 segundos entre cada alerta
        });
      }
    },
    setSelects() {
      this.tiposPrestador = this.tiposPrestadorItems;
      this.tiposDoc = this.tiposDocItems;
      this.setProvincias();
    },
    async setProvincias(provId) {
      this.provinciaSelected = null;
      this.isProvinciaSelectLoading = true;
      this.provincias = await this.getProvinciasAll();
      if (provId) {
        this.provinciaSelected = this.provincias.find((x) => x.id == provId);
      }
      this.isProvinciaSelectLoading = false;
    },
    async searchPrestador() {
      this.isSearchLoading = true;
      this.isDataLoading = true;
      const data = {
        cuit: this.cuitBusqueda.toString().replaceAll("-", ""),
        financiadorId: this.financiadorId,
        preId:
          this.usuarioEmisorItem != null ? this.usuarioEmisorItem.preId : null,
      };
      try {
        const response = await this.searchPrestadorByCuit(data);
        if (response.status === 200) {
          this.prestadorSearched = true;
          this.prestadorFounded = true;
          if (this.usuarioEmisorItem == null) {
            this.setAlert({
              type: "success",
              message:
                "Se ha encontrado un usuario existente en el sistema con los datos ingresados.",
            });
          }
          this.apeNom = response.data.preNomApe;
          this.cuil = response.data.preCuit;
          this.correo = response.data.email;
          this.usuarioId = response.data.usuarioId;
          this.preId = response.data.preId;
          this.usuNom = response.data.usuarioNombre;
          this.preXFinId = response.data.preXFinId;
          this.codigoRefeps = response.data.codigoRefeps;
          this.tipoDocSelected = this.tiposDocItems.find(
            (x) => x.id === response.data.preTipoDoc.id
          );
          this.sexoSelected = response.data.preSexo ? this.sexos.find(s => s.value === response.data.preSexo) : null;
          this.nroDoc = response.data.preNroDoc.toString();
          
          await this.setProvincias(response.data.provId);
          
          // Usar el array de relaciones que viene del backend
          if (response.data.relaciones && response.data.relaciones.length > 0) {
            this.relaciones = response.data.relaciones.map(rel => ({
              preXFinId: rel.preXFinId, // ID para editar/eliminar
              tipoPrestadorSelected: this.tiposPrestador.find(
                (x) => x.id == rel.tipoPrestadorId
              ),
              tipoPrestadorTexto: rel.tipoPrestadorTexto || "", // Cargar desde backend o vacío
              matriculaProv: rel.matriculaProv,
              provinciaSelected: this.provincias.find((x) => x.id == rel.provId),
              especialidades: [], // No tenemos especialidades en prestadores existentes
              especialidadTexto: rel.especialidadTexto || "",
              entidadEmisoraMatricula: rel.entidadEmisoraMatricula,
              domicilioPrescripcion: rel.domicilioPrescripcion,
              telefono: rel.telefono
            }));
          } else {
            // Fallback al formato anterior por compatibilidad
            this.relaciones = [{
              preXFinId: response.data.preXFinId,
              tipoPrestadorSelected: this.tiposPrestador.find(
                (x) => x.id == response.data.tipoPreId
              ),
              tipoPrestadorTexto: response.data.tipoPreNom || "",
              matriculaProv: response.data.matriculaProv,
              provinciaSelected: this.provincias.find((x) => x.id == response.data.provId),
              especialidades: [],
              especialidadTexto: "",
              entidadEmisoraMatricula: response.data.preEntEmisoraMatricula,
              domicilioPrescripcion: response.data.preDireccion,
              telefono: response.data.preTelefono
            }];
          }
          
          // Validar con SISA para completar datos faltantes y detectar inconsistencias
          this.lastValidatedCuil = "";
          await this.onCuilChange();
        } else if (response.status === 204) {
          this.prestadorSearched = true;
          this.prestadorNotFound = true;
          this.cuil = this.cuitBusqueda;
          this.usuNom = this.cuitBusqueda.replaceAll("-", "");
          this.relaciones = [];
          // Derivar N° documento del CUIL y proponer datos SISA
          const parts = (this.cuitBusqueda || "").toString().split("-");
          if (parts.length === 3) {
            this.nroDoc = parts[1];
          } else {
            const digits = (this.cuitBusqueda || "").toString().replaceAll("-", "");
            if (digits.length > 3) this.nroDoc = digits.slice(2, -1);
          }
          // Resetear el último CUIL validado para permitir la validación inicial
          this.lastValidatedCuil = "";
          await this.onCuilChange();
          
          // Asegurar que siempre haya al menos una relación vacía para cargar
          if (!this.relaciones || this.relaciones.length === 0) {
            this.relaciones = [this.createRelacionBlank()];
          }
          
          this.setAlert({
            type: "info",
            message:
              "No se ha encontrado un usuario existente en el sistema con los datos ingresados. Se han pre-cargado los datos disponibles desde REFEPS para facilitar la creación del usuario.",
          });
        } else return;
      } catch (error) {
        console.error("Error", error);
      } finally {
        this.isSearchLoading = false;
        this.isDataLoading = false;
      }
    },
    setUserName(cuil) {
      this.usuNom = cuil.replaceAll("-", "");
    },
    createRelacionBlank() {
      return {
        preXFinId: null, // Para nuevas relaciones
        tipoPrestadorSelected: null, // Faltaba este campo
        tipoPrestadorTexto: "",
        matriculaProv: "",
        entidadEmisoraMatricula: "",
        provinciaSelected: null,
        especialidades: [],
        especialidadTexto: "",
        telefono: "",
        domicilioPrescripcion: "",
      };
    },
    addRelacionManual() {
      this.relaciones.push({
        tipoPrestadorSelected: null,
        tipoPrestadorTexto: "",
        matriculaProv: "",
        provinciaSelected: null,
        especialidades: [],
        especialidadTexto: "",
        entidadEmisoraMatricula: "",
        domicilioPrescripcion: "",
        telefono: "",
      });
    },
    removeRelacion(idx) {
      if (this.relaciones.length <= 1) {
        this.setAlert({
          type: "warning",
          message: "Debe mantener al menos una relación.",
        });
        return;
      }
      this.relaciones.splice(idx, 1);
    },
    async save() {
      this.isLoading = true;

      const data = {
        usuarioId: this.usuarioId,
        usuarioNombre: this.usuNom,
        email: this.correo,
        financiador: { id: this.financiadorId, value: "" },
        preId: this.preId,
        preNomApe: this.apeNom,
        preTipoDoc: this.tipoDocSelected,
        preNroDoc: this.nroDoc.replaceAll(".", ""),
        preCuit: this.cuil.replaceAll("-", ""),
        preXFinId: this.preXFinId,
        codigoRefeps: this.codigoRefeps,
        preSexo: this.sexoSelected?.value || null,
      };

      // SIEMPRE enviar el array de relaciones (tanto para nuevos como existentes)
      if (this.relaciones?.length) {
        data.relaciones = this.relaciones.map(rel => ({
          preXFinId: rel.preXFinId, // Incluir ID para editar/eliminar
          tipoPrestadorId: this.financiadorUsaGecros ? rel.tipoPrestadorSelected?.id : null,
          tipoPrestadorTexto: this.financiadorUsaGecros ? null : rel.tipoPrestadorTexto,
          matriculaProv: rel.matriculaProv,
          provId: rel.provinciaSelected?.id,
          especialidadTexto: rel.especialidadTexto,
          entidadEmisoraMatricula: rel.entidadEmisoraMatricula,
          domicilioPrescripcion: rel.domicilioPrescripcion,
          telefono: rel.telefono
        }));
      }
      try {
        const response = await this.saveUsuarioEmisor(data);
        if (response.status === 200) {
          // Mostrar mensaje de éxito
          if (this.usuarioId == null)
            this.setAlert({
              type: "success",
              message:
                "Guardado con éxito. La contraseña del usuario se ha enviado al mail ingresado.",
            });
          else
            this.setAlert({ type: "success", message: "Guardado con éxito." });
          
          // Mostrar advertencias si las hay
          if (response.data.warnings && response.data.warnings.length > 0) {
            // Esperar un poco para que se vea el mensaje de éxito primero
            setTimeout(() => {
              response.data.warnings.forEach(warning => {
                this.setAlert({
                  type: "warning",
                  message: warning
                });
              });
            }, 1500);
          }
        }

        this.closeModal(true);
      } catch (error) {
        console.error("Error al guardar cambios", error);
      } finally {
        this.isLoading = false;
      }
    },
    closeModal(reload) {
      this.$emit("closeDialog", reload);
    },
  },
};
</script>

<style scoped>
.eye-icon {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
</style>
